/* ============================================================
   OneCircle – "Direkt zur Kasse" (Buy Now)
   Datei: assets/oc-buy-now.js
   ------------------------------------------------------------
   Gemeinsamer Handler fuer den Direkt-zur-Kasse-Button im
   Quick-View (snippets/product-quick-view.liquid) und auf den
   Produktkarten (snippets/oc-product-card.liquid).

   - Init via Flag window.__ocBuyNowInit -> nur EIN Click-Handler
     pro Page-Load, egal wie oft das Script-Tag gerendert wird.
   - Event-Delegation auf [data-oc-buy-now].
   - Karte: Variante kommt fest aus data-variant-id (erste
     verfuegbare Variante, Menge 1).
   - Quick-View: Variante + Menge werden LIVE aus dem Formular des
     Modals gelesen (input[name="id"] wird beim Variantenwechsel
     vom Theme aktualisiert).
   - /cart/add.js (AJAX, JSON) -> bei Erfolg Redirect /checkout,
     bei Fehler Fehlermeldung ([data-oc-buy-now-msg] im QV bzw.
     Button-Label-Feedback auf der Karte).
   - preventDefault + stopPropagation: der Karten-Button steckt im
     <a> der Karte und darf NICHT zur Produktseite navigieren.
   - Bestehende ATC-Logik (atc-submit-form, oc-product-card.js)
     bleibt unberuehrt; identischer Cart-Endpoint wie Webkul.
   ============================================================ */
(function () {
  if (window.__ocBuyNowInit) return;
  window.__ocBuyNowInit = true;

  var CART_ADD_URL = (window.Shopify && Shopify.routes && Shopify.routes.cart_add_url) || '/cart/add.js';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-oc-buy-now]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled || btn.classList.contains('is-loading')) return;

    var variantId = btn.getAttribute('data-variant-id');
    var qty = 1;
    var msg = null;

    if (!variantId) {
      /* Quick-View: live aus dem Modal-Formular lesen */
      var scope = btn.closest('.modal-component_wrapper') || btn.closest('.modal-component') || document;
      var form = scope.querySelector('form[action*="/cart/add"]') || scope.querySelector('atc-submit-form form');
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        variantId = idInput && idInput.value;
        var qtyEls = form.querySelectorAll('[name="quantity"]');
        if (qtyEls.length) {
          var q = parseInt(qtyEls[qtyEls.length - 1].value, 10);
          if (q > 0) qty = q;
        }
      }
      msg = scope.querySelector('[data-oc-buy-now-msg]');
    }

    if (!variantId) return;

    var defaultLabel = btn.textContent;
    btn.classList.add('is-loading');
    btn.disabled = true;
    if (msg) { msg.hidden = true; msg.textContent = ''; }

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', String(qty));

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error((err && (err.description || err.message)) || 'Hinzufügen fehlgeschlagen');
          });
        }
        return res.json();
      })
      .then(function () {
        /* Erfolg: direkt zur Kasse (Button bleibt im Lade-Zustand) */
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (msg) {
          msg.textContent = err.message;
          msg.hidden = false;
        } else {
          btn.textContent = 'Fehler – erneut versuchen';
          setTimeout(function () { btn.textContent = defaultLabel; }, 2200);
        }
      });
  });
})();